module.exports = __webpack_public_path__ + "static/cta-1-moc-1-3a71e44ce68d207c40948b9ddd3201cb.png";